import gql from "graphql-tag";

const Props = gql`
	fragment NoteCategoryProps on NoteCategory {
		id
		created_at
		name
		image
	}
`;

const GET_LIST = gql`
	query GetNoteCategories($site: ID!) {
		GetNoteCategories(site: $site) {
			docs {
				...NoteCategoryProps
			}
		}
	}
	${Props}
`;

const GET_CARE_NOTE_LIST = gql`
	query GetCareNoteCategoryList($site: ID!) {
		GetCareNoteCategories(site: $site) {
			docs {
				...NoteCategoryProps
			}
		}
	}
	${Props}
`;

const NEW_NOTE_ITEM = gql`
	mutation NewNoteCategory($model: NoteCategoryInput!) {
		NewNoteCategory(model: $model) {
			message
			doc {
				...NoteCategoryProps
			}
		}
	}
	${Props}
`;

const NEW_CARE_NOTE_ITEM = gql`
	mutation NewCareNoteCategory($model: NoteCategoryInput!) {
		NewCareNoteCategory(model: $model) {
			message
			doc {
				...NoteCategoryProps
			}
		}
	}
	${Props}
`;

const UPDATE_NOTE_ITEM = gql`
	mutation UpdateNoteCategory($id: ID!, $name: String!, $icon: String!) {
		UpdateNoteCategory(name: $name, id: $id, icon: $icon) {
			message
			doc {
				...NoteCategoryProps
			}
		}
	}
	${Props}
`;
const REMOVE = gql`
	mutation RemoveActivity($id: ID!) {
		DeleteNoteCategory(id: $id) {
			message
			doc {
				status
				id
			}
		}
	}
`;
export {
	GET_LIST,
	NEW_NOTE_ITEM,
	UPDATE_NOTE_ITEM,
	Props,
	REMOVE,
	GET_CARE_NOTE_LIST,
	NEW_CARE_NOTE_ITEM
};
